import { Component } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LoadingStatusService } from './services/loading-status.service';
import { VegWizardStateMachineService } from './veg-wizard/services/veg-wizard-state-machine.service';

import { SharedModule } from './shared/shared.module';
import { AsyncPipe, NgClass } from '@angular/common';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
  imports: [
    RouterOutlet,
    AsyncPipe,
    HeaderComponent,
    FooterComponent,
    NgClass,
    SharedModule,
    RouterLink,
    MatProgressSpinnerModule
]
})
export class AppComponent {

  errorMailToAddress = environment.errorMailTo;
  title = 'osacn';

  constructor(
    public router: Router,
    public lss: LoadingStatusService,
    public sms: VegWizardStateMachineService) {
  }

  onActivate(event: any) {
    // https://stackoverflow.com/questions/48048299/angular-5-scroll-to-top-on-every-route-click
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

  }
}
